// removed by extract-text-webpack-plugin
module.exports = {"warnContain":"_3sQDs0f7q9LSfXwNzgKPFg","message":"_3AXGRZYMa6wRRRdw28_s6_","buttonContain":"_1J1OAB6UF-vTGVUVnjfT-6","deleteButton":"_1LSL9sHbINFYr3DJuZJB8K","cancelButton":"_1erBHKxOYVtePjTUCV0cO"};


//////////////////
// WEBPACK FOOTER
// ./src/componentStyles/ChoreDeleteWarn.css
// module id = 388
// module chunks = 0